import{p as a,a as r}from"./dates-lbaNvUdr.js";const s={parse:a,format:r};export{s as isoAdapter};
//# sourceMappingURL=date-adapter.js.map
